import React, { useEffect, useState } from "react";
import "./NavPages.css";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import goldLogo from "../../Assets/Images/footer/logo-footer-new.svg";

function NavPages({ translations, language, setLanguage }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // React Router hook to get the current location
  // const [language, setLanguage] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 1;

      setIsScrolled(scrollPosition > scrollThreshold);
    };

    // Check on mount
    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isActive = (path) => location.pathname === path; // Now using location.pathname for real-time checking

  // const toggleLanguage = () => {
  //   const newLang = language === "en" ? "ar" : "en";
  //   setLanguage(newLang);
  //   localStorage.setItem("lang", newLang);
  //   // Reload the page to apply changes if you're using static content
  //   window.location.reload();
  // };
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const selectLanguage = (lang) => {
    handleLanguageChange({ target: { value: lang } });
  };

  const toggleLanguage = () => {
    selectLanguage(language === "en" ? "ar" : "en");
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`home-navbar ${isScrolled ? "scrolled-navbar" : "unscrolled"}`}
    >
      <Container>
        <Navbar.Brand href="/home">
          <img
            src={
              isScrolled ? goldLogo : require("../../Assets/Images/logo.png")
            }
            className="nav-logo"
            alt="Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Link
              reloadDocument
              to="/home"
              className={`nav-link ${
                isActive("/home") || isActive("/") ? "active" : ""
              }`}
            >
              {translations?.result?.home ? translations?.result?.home : "Home"}
            </Link>
            <Link
              to="/details/ARCHITECTURE & DESIGNS"
              className={`nav-link ${
                isActive("/details/ARCHITECTURE & DESIGNS") ? "active" : ""
              }`}
            >
              {translations?.result?.Architecture
                ? translations?.result?.Architecture
                : "Architecture"}
            </Link>
            {/* <Link
              to="/details/Designs"
              className={`nav-link ${isActive("/details/Designs") ? "active" : ""}`}
            >
              {translations?.result?.design
                ? translations?.result?.design
                : "Design"}
            </Link> */}
            <Link
              to="/details/E-Marketing"
              className={`nav-link ${isActive("/details/E-Marketing") ? "active" : ""}`}
            >
              {translations?.result?.Emarketing
                ? translations?.result?.Emarketing
                : "E-marketing"}
            </Link>
            <Link
              to="/details/Branding & Visual Identity"
              className={`nav-link ${isActive("/details/Branding & Visual Identity") ? "active" : ""}`}
            >
              {translations?.result?.Branding
                ? translations?.result?.Branding
                : "Branding"}
            </Link>
            <Link
              reloadDocument
              to="/services"
              className={`nav-link ${isActive("/services") ? "active" : ""}`}
            >
              {translations?.result?.Services
                ? translations?.result?.Services
                : "Services"}
            </Link>
          </Nav>
          <button onClick={toggleLanguage} className="nav-link lang-toggle-btn">
            {language === "ar" ? "EN" : "AR"}
          </button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavPages;
